module.exports = __webpack_public_path__ + "ed5c465aad8ef4caa033bf747f72b3d2.woff2";